// import { Api } from '@/service';
import codes from '@/codes'

//restful api
import { detect as integrity } from '@/service/api/integrity'
const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}
});

const i18n_fields = {
  EN: [
    { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'Target', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '시간', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: '행위', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '대상', sortable: false },
  ]
}

export default {
  props: ['is_main'],
  data : () => {
    return {
      codes,
      so : default_opt(),
      selected : '',
      limit : 15
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    },
  },
  methods: {
    save(item) {
      // let snapshot = [[item.target, item.hash_selected.key, item.hash_selected.value]]
      // Api.Manager_Call({target: 'integrity.detect', cmd : 'update', body : { id : item.id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id, is_apply : true }})
      // Api.Manager_Call({target: 'integrity', cmd : 'update', body : { id : item.id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id, is_apply : true }})
      // this.$toastr.s('Application completed');

    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('WMDS', 'refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [{ name : "type", value : "wmds", op : "="}], columns : ["id", "created_at", "action", "target"] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='}, { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return integrity.listDetect(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) );
    },
    detail(item) { console.log(item); this.$router.push(`domainresult/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('site.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created() { console.log('WMDS', 'integrity.vue', 'created'); },
  destroyed() { console.log('WMDS', 'integrity.vue', 'destroyed'); },
  mounted() { console.log('WMDS', 'integrity.vue', 'mounted'); },
}